module.exports = __webpack_public_path__ + "img/doctor-avatar.a695e8a3.svg";